import { faroTableComparator } from "@components/common/faro-table/faro-table-utils";
import { CreditPurchasesHistoryHeaders } from "@components/table/transactions/transactions-table-utils";
import { CreditSubscriptionStatus } from "@custom-types/credit-types";
import { Chip, FontWeights } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { gridStringOrNumberComparator } from "@mui/x-data-grid-pro";
import { CREDIT_DISPLAY_NAME } from "@src/constants/credit-constants";
import { getSubscriptionPackageName, getSubscriptionStatus } from "@utils/credit-transaction-utils";
import { formatNumber, nounPluralize } from "@utils/data-display";
/** Return all the possible columns for the Credit Purchases History table */
export function getCreditPurchasesColumns({
  formatDate
}) {
  return {
    [CreditPurchasesHistoryHeaders.package]: {
      field: CreditPurchasesHistoryHeaders.package,
      flex: 1,
      minWidth: 220,
      renderCell: params => {
        return <var>{getSubscriptionPackageName(params.row.entity)}</var>;
      },
      valueGetter: (_, row) => getSubscriptionPackageName(row.entity),
      // eslint-disable-next-line @typescript-eslint/naming-convention -- name given by package
      sortable: true,
      sortComparator: (v1, v2, cp1, cp2) => faroTableComparator(v1, v2, cp1, cp2, gridStringOrNumberComparator)
    },
    [CreditPurchasesHistoryHeaders.purchasedDate]: {
      field: CreditPurchasesHistoryHeaders.purchasedDate,
      flex: 1,
      minWidth: 220,
      renderCell: params => {
        return <var>{formatDate(params.row.entity.startDate)}</var>;
      },
      valueGetter: (_, row) => row.entity.startDate,
      // eslint-disable-next-line @typescript-eslint/naming-convention -- name given by package
      sortable: true,
      sortComparator: (v1, v2, cp1, cp2) => faroTableComparator(v1, v2, cp1, cp2, gridStringOrNumberComparator)
    },
    [CreditPurchasesHistoryHeaders.expirationDate]: {
      field: CreditPurchasesHistoryHeaders.expirationDate,
      flex: 1,
      minWidth: 220,
      renderCell: params => {
        return <var>{formatDate(params.row.entity.expiresAt)}</var>;
      },
      valueGetter: (_, row) => row.entity.expiresAt,
      // eslint-disable-next-line @typescript-eslint/naming-convention -- name given by package
      sortable: true,
      sortComparator: (v1, v2, cp1, cp2) => faroTableComparator(v1, v2, cp1, cp2, gridStringOrNumberComparator)
    },
    [CreditPurchasesHistoryHeaders.status]: {
      field: CreditPurchasesHistoryHeaders.status,
      flex: 1,
      minWidth: 220,
      renderCell: params => {
        const currentStatus = getSubscriptionStatus(params.row.entity);
        const isUsedOrExpired = currentStatus === CreditSubscriptionStatus.used || currentStatus === CreditSubscriptionStatus.expired;
        return <Chip label={getSubscriptionStatus(params.row.entity)} size="small" variant="filled" color={isUsedOrExpired ? "error" : "primary"} />;
      },
      valueGetter: (_, row) => getSubscriptionStatus(row.entity),
      // eslint-disable-next-line @typescript-eslint/naming-convention -- name given by package
      sortable: true,
      sortComparator: (v1, v2, cp1, cp2) => faroTableComparator(v1, v2, cp1, cp2, gridStringOrNumberComparator)
    },
    [CreditPurchasesHistoryHeaders.creditsRemaining]: {
      field: CreditPurchasesHistoryHeaders.creditsRemaining,
      flex: 1,
      minWidth: 220,
      renderCell: params => {
        const hasExpiredSubHasCredits = params.row.entity.availableCredit > 0 && getSubscriptionStatus(params.row.entity) === CreditSubscriptionStatus.expired;
        return <Box sx={{
          fontSize: "12px",
          fontWeight: FontWeights.SemiBold,
          color: hasExpiredSubHasCredits ? "error.main" : "inherit"
        }}>
            {formatNumber(params.row.entity.availableCredit)}{" "}
            {nounPluralize({
            shouldShowCounter: false,
            counter: params.row.entity.availableCredit,
            word: CREDIT_DISPLAY_NAME
          })}
          </Box>;
      },
      valueGetter: (_, row) => row.entity.availableCredit,
      // eslint-disable-next-line @typescript-eslint/naming-convention -- name given by package
      sortable: true,
      sortComparator: (v1, v2, cp1, cp2) => faroTableComparator(v1, v2, cp1, cp2, gridStringOrNumberComparator)
    }
  };
}